import {createStateMaker} from '@shared/helpers/object'

import {RefundCode} from '@web/core/constants'

import {DEFAULT_PRE_APPROVAL_PAYMENT_LIMIT} from '../constants'
import {PayNextState} from '../interfaces'

export const getInitialState = (): PayNextState => ({
    expirationDepositDate: '',
    virtualAccount: {
        bankCodes: [],
        selected: {
            code: null,
        },
        billing: {
            pgCp: '',
            pgId: '',
            minimumAmount: null,
            maximumAmount: null,
        },
    },
    refund: {
        method: RefundCode.BANK_ACCOUNT,
        accounts: [],
        selected: {
            accountKey: null,
        },
    },
    familyPay: {
        status: 'IDLE',
        billing: {
            // 서버에서 별도의 값이 내려오지 않음
            minimumAmount: 10,
            maximumAmount: null,
        },
        userStatus: null,
        memberPaymentInfo: null,
        payerPaymentInfo: null,
        role: null,
        subscribed: false,
        preApprovalPaymentLimitPerTransaction: DEFAULT_PRE_APPROVAL_PAYMENT_LIMIT,
    },
})

export const makeMock = createStateMaker<PayNextState>(getInitialState)
